import { Link } from "react-router-dom";

export const profileSectionCard =
	"bg-white rounded-xl border border-[#E2E8F0] p-4 sm:p-5 shadow-[0_1px_3px_rgba(15,23,42,0.04)]";

/** Treat API null / literal "null" / whitespace as empty. */
export function profileFieldText(value) {
	if (value == null) return "";
	const s = String(value).trim();
	const lowered = s.toLowerCase();
	if (s === "" || lowered === "null" || lowered === "undefined" || lowered === "none") {
		return "";
	}
	return s;
}

export function ProfileSection({ title, children, className = "" }) {
	return (
		<section className={[profileSectionCard, className].filter(Boolean).join(" ")}>
			{title ? (
				<h2 className="font-Vazir-700 text-[15px] text-darkBlue mb-3 pb-2 border-b border-[#E2E8F0] text-center">
					{title}
				</h2>
			) : null}
			<div className="text-center">{children}</div>
		</section>
	);
}

export function ProfileEmpty({ children, hint }) {
	return (
		<div className="py-2">
			<p className="font-Vazir-600 text-[15px] text-darkBlue">{children}</p>
			{hint ? (
				<p className="mt-1 font-Vazir-400 text-[13px] text-darkBlue/50">{hint}</p>
			) : null}
		</div>
	);
}

export function ProfileSectionError({ message }) {
	if (!message) return null;
	return (
		<p className="text-center font-Vazir-400 text-[14px] text-error mt-3">{message}</p>
	);
}

export function ProfileOutlineLink({ to, children, className = "" }) {
	return (
		<Link
			to={to}
			className={[
				"inline-flex items-center justify-center",
				"font-Vazir-600 text-[13px] text-midGray",
				"px-4 py-2 rounded-xl border border-[#E2E8F0] bg-white",
				"hover:bg-lightCta hover:text-darkBlue hover:border-darkBlue/20 transition-colors",
				className,
			].join(" ")}
		>
			{children}
		</Link>
	);
}
